'use strict';

/**
 * Awards
 */
waApp.controllers.Awards = {
	_addEdit: function() {
		$('#award-type').change(function(e) {
			e.preventDefault();
			let value = $(this).val();
			// PERSONAL
			if (value == 'd8cbe512-f574-474b-a1f4-64b93cf917d4') {
				$('#project-id').hide();
				$('#competition-id').hide();
				$('#placing').hide();

				// Project
			} else if (value == '89024ffe-b622-4df2-a7ff-7ce47db01db3') {
				$('#project-id').show();
				$('#competition-id').hide();
				$('#placing').show();

				// Competition
			} else if (value == 'edf94e50-1fc6-4545-a240-a6e3605c7212') {
				$('#project-id').hide();
				$('#competition-id').show();
				$('#placing').show();
			} else {
				$('#project-id').hide();
				$('#competition-id').hide();
				$('#placing').hide();
			}
		});
		$('#award-type').trigger('change');
	},
	add: function() {
		waUtils.inputLanguageToggle();
		waApp.controllers.Awards._addEdit();
	},
	edit: function() {
		waUtils.inputLanguageToggle();
		waApp.controllers.Awards._addEdit();
	}
};
